export { default } from './BadgeGuarantee';
